import moment from "moment";

export const changeDateTimeFormat = (change_date) => {
    var change_date = new Date(change_date);
    var month = change_date.getMonth() + 1;
    var date = change_date.getDate();;
    var year = change_date.getFullYear();
    if (month < 10){
        month = '0' + month;
    }
    if (date < 10){
        date = '0' + date;
    }
    var new_date = year + '-' + month + '-' + date
    return new_date;
}

export const formatDate = (date) => {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    if (dd < 10) { dd = '0' + dd }
    if (mm < 10) { mm = '0' + mm }
    date = yyyy + '-' + mm + '-' + dd;
    return date
  }


 export const changeDateAndTimeFormat = (_date) => {
    var change_date = new Date(_date);
    var month = change_date.getMonth() + 1;
    var date = change_date.getDate();
    var hours = change_date.getHours();
    var minutes = change_date.getMinutes();
    var seconds = change_date.getSeconds();
    var year = change_date.getFullYear();
    if (month < 10){
        month = '0' + month;
    }
    if (date < 10){
        date = '0' + date;
    }
    if (hours < 10){
        hours = '0' + hours;
    }
    if (minutes < 10){
        minutes = '0' + minutes;
    }
    if (seconds < 10){
        seconds = '0' + seconds;
    }
    var new_date = year + '-' + month + '-' + date +' '+ hours + ':' + minutes + ':' + seconds;
    return new_date;
}

export const days = [
    "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen", "Twenty",
    "Twentyone", "Twentytwo", "Twentythree", "Twentyfour", "Twentyfive", "Twentysix", "Twentyseven", "Twentyeight", "Twentynine", "Thirty",
    "Thirtyone"
];

export const months = [
    "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
];

export const formatDateDDMMYYYY = (date) => {
    const inputDate = date;
    const outputFormat = "DD-MM-YYYY";
    const formattedDate = moment.utc(inputDate).format(outputFormat);
    return formattedDate;
}
export const monthsMap = {
  "Jan": 0,
  "Feb": 1,
  "Mar": 2,
  "Apr": 3,
  "May": 4,
  "Jun": 5,
  "Jul": 6,
  "Aug": 7,
  "Sep": 8,
  "Oct": 9,
  "Nov": 10,
  "Dec": 11
};

export const getMonthIndex = (monthName) =>  {
    return monthsMap[monthName];
}

export function capitalizeEachWord(str) {
    if (!str || Array.isArray(str)) return '';
    return str?.split(' ')
              ?.map(word => word?.charAt(0).toUpperCase() + word?.slice(1)?.toLowerCase())
              ?.join(' ');
  }